import { LayoutDashboard, ShoppingBag, UtensilsCrossed, ChefHat, Newspaper, Megaphone, FileText, Tags, Home, Image, Menu, PanelBottom, UserPlus, BadgeEuro, Search, Eye, Languages, Settings, Bell, MapPin, Mail, MessageSquare, Plug, ShieldCheck, Users, Database, ScrollText, UserCircle } from "lucide-react";

export const NAV_GROUPS = [
  { title: "Dashboard", items: [
    { id: "overview", label: "Overview", icon: LayoutDashboard, perm: "overview" },
    { id: "orders", label: "Orders", icon: ShoppingBag, perm: "orders" },
  ] },
  { title: "Catalog", items: [
    { id: "dishes", label: "Food & Menu", icon: UtensilsCrossed, perm: "catalog" },
    { id: "categories", label: "Food categories", icon: Tags, perm: "catalog" },
    { id: "chefs", label: "Chefs", icon: ChefHat, perm: "catalog" },
  ] },
  { title: "Content", items: [
    { id: "blog", label: "Blog", icon: Newspaper, perm: "content" },
    { id: "announcements", label: "Announcements", icon: Megaphone, perm: "content" },
    { id: "pages", label: "Web Pages", icon: FileText, perm: "content" },
  ] },
  { title: "Website", items: [
    { id: "homepage", label: "Homepage", icon: Home, perm: "website" },
    { id: "banners", label: "Banners", icon: Image, perm: "website" },
    { id: "navigation", label: "Navigation menu", icon: Menu, perm: "website" },
    { id: "footer", label: "Footer", icon: PanelBottom, perm: "website" },
    { id: "onboarding", label: "Sign-up & login", icon: UserPlus, perm: "website" },
    { id: "pricing", label: "Pricing & service", icon: BadgeEuro, perm: "website" },
    { id: "seo", label: "SEO", icon: Search, perm: "website" },
    { id: "visibility", label: "Visibility", icon: Eye, perm: "website" },
    { id: "translations", label: "Translations", icon: Languages, perm: "website" },
  ] },
  { title: "Platform settings", items: [
    { id: "general", label: "General", icon: Settings, perm: "settings" },
    { id: "notifications", label: "Notifications", icon: Bell, perm: "settings" },
    { id: "locations", label: "Service areas", icon: MapPin, perm: "settings" },
    { id: "email", label: "Email", icon: Mail, perm: "settings" },
    { id: "sms", label: "SMS", icon: MessageSquare, perm: "settings" },
    { id: "integrations", label: "Integrations", icon: Plug, perm: "settings" },
    { id: "languages", label: "Languages", icon: Languages, perm: "settings" },
    { id: "privacy", label: "Privacy & security", icon: ShieldCheck, perm: "settings" },
    { id: "users", label: "Users & roles", icon: Users, perm: "users" },
    { id: "data", label: "Data & backup", icon: Database, perm: "data" },
    { id: "audit", label: "Audit log", icon: ScrollText, perm: "audit" },
  ] },
  { title: "Account", items: [{ id: "account", label: "My account", icon: UserCircle, perm: null }] },
];
